import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import { useTranslation } from "react-i18next";

const EmptyCart = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const suggestedProducts = [
    {
      id: 1,
      name: t("wirelessHeadphones"),
      price: 79.99,
      originalPrice: 99.99,
      image:
        "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=300&h=300&fit=crop",
      rating: 4.5,
    },
    {
      id: 2,
      name: t("smartFitnessWatch"),
      price: 199.99,
      image:
        "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=300&h=300&fit=crop",
      rating: 4.8,
    },
    {
      id: 3,
      name: t("premiumCoffeeMaker"),
      price: 149.99,
      originalPrice: 179.99,
      image:
        "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=300&h=300&fit=crop",
      rating: 4.6,
    },
  ];

  const handleContinueShopping = () => {
    navigate("/");
  };

  const handleProductClick = (productId) => {
    navigate(`/product/${productId}`);
  };

  return (
    <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12 lg:py-24 py-12">
      {/* Empty State Illustration */}
      <div className="text-center mb-16">
        <div className="w-48 h-48 mx-auto mb-8 bg-global-1 rounded-full flex items-center justify-center shadow-lg">
          <Icon name="ShoppingCart" size={96} className="text-indigo-200" />
        </div>

        <h1 className="text-4xl font-extrabold text-gray-900 mb-5">
          {t("yourCartIsEmpty")}
        </h1>
        <p className="text-lg text-gray-600 mb-10 max-w-lg mx-auto">
          {t("emptyCartMessage")}
        </p>

        <Button
          variant="default"
          size="lg"
          onClick={handleContinueShopping}
          // iconName="ArrowLeft"
          // iconPosition="left"
          className="px-8 py-4 text-white rounded-full shadow-xl hover:bg-global-5 active:scale-95 transition-transform duration-150"
        >
          {t("continueShopping")}
        </Button>
      </div>

      {/* Features Section */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
        <div className="text-center p-8 bg-white border border-gray-200 rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300">
          <div className="w-14 h-14 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-5">
            <Icon name="Truck" size={28} className="text-indigo-600" />
          </div>
          <h3 className="font-semibold text-gray-900 mb-3 text-lg">
            {t("freeShipping")}
          </h3>
          <p className="text-sm text-gray-500 leading-relaxed">
            {t("freeShippingMessage")}
          </p>
        </div>

        <div className="text-center p-8 bg-white border border-gray-200 rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300">
          <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-5">
            <Icon name="RotateCcw" size={28} className="text-green-600" />
          </div>
          <h3 className="font-semibold text-gray-900 mb-3 text-lg">
            {t("easyReturns")}
          </h3>
          <p className="text-sm text-gray-500 leading-relaxed">
            {t("easyReturnsMessage")}
          </p>
        </div>

        <div className="text-center p-8 bg-white border border-gray-200 rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300">
          <div className="w-14 h-14 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-5">
            <Icon name="Shield" size={28} className="text-pink-600" />
          </div>
          <h3 className="font-semibold text-gray-900 mb-3 text-lg">
            {t("securePayment")}
          </h3>
          <p className="text-sm text-gray-500 leading-relaxed">
            {t("securePaymentMessage")}
          </p>
        </div>
      </div>

      {/* Suggested Products (Optional Enhancement) */}
      {/* Uncomment and style if you want to show suggested products */}
      {/* 
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-6">{t('youMightLike')}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {suggestedProducts.map(product => (
            <div
              key={product.id}
              onClick={() => handleProductClick(product.id)}
              className="cursor-pointer bg-white border border-gray-200 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 p-4 flex flex-col items-center"
            >
              <img
                src={product.image}
                alt={product.name}
                className="w-40 h-40 object-cover rounded-lg mb-4"
              />
              <h3 className="text-lg font-semibold text-gray-900 mb-1">{product.name}</h3>
              <div className="flex items-center space-x-2 mb-2">
                <span className="text-indigo-600 font-bold text-lg">${product.price.toFixed(2)}</span>
                {product.originalPrice && (
                  <span className="text-gray-400 line-through text-sm">${product.originalPrice.toFixed(2)}</span>
                )}
              </div>
              <div className="text-yellow-400">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Icon
                    key={i}
                    name={i < Math.floor(product.rating) ? "Star" : "StarOutline"}
                    size={16}
                    className="inline-block"
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      */}
    </div>
  );
};

export default EmptyCart;
